import { ref } from 'vue';

const isLoading = ref(false );

const useSpinner = () => {
    const showSpinner = () => {
        isLoading.value = true;
    };
    const hideSpinner = () => {
        isLoading.value = false;
    };


    return { showSpinner, hideSpinner, isLoading };
};

export default useSpinner;
